import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { LOGIN_FAILURE_REASONS } from '@didaskill/domain/auth/constants';
import { AlertBanner, Card, Typography } from '@didaskill/ui/design-system';

import DidaskillLogo from '../../../../../assets/logo/DidaskillWithIcon.svg';
import messages from '../../LoginPage.messages';
import * as styles from '../../LoginPage.styles';

const getErrorMessage = (reason: LOGIN_FAILURE_REASONS) => {
  switch (reason) {
    case LOGIN_FAILURE_REASONS.BLOCKED:
      return messages.LOGIN_BLOCKED_ERROR;
    default:
      return messages.LOGIN_ERROR;
  }
};

export type LoginGoogleCardProps = {
  hasError?: boolean;
  reason?: LOGIN_FAILURE_REASONS;
};

const LoginGoogleCardBase = ({ hasError = false, reason = null }: LoginGoogleCardProps) => {
  return (
    <Card css={styles.card}>
      <Card.Body css={styles.loginCardBody}>
        <svg width={250} height={39}>
          <DidaskillLogo />
        </svg>
        <div>
          <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>
            <FormattedMessage {...messages.CONNECTION_INFO} />
          </Typography>
        </div>
        {hasError && (
          <AlertBanner variant={AlertBanner.VARIANTS.DANGER}>
            <FormattedMessage
              {...getErrorMessage(reason)}
              values={{
                p: (chunks) => (
                  <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR} element="p">
                    {chunks}
                  </Typography>
                ),
                b: (chunks) => (
                  <Typography variant={Typography.VARIANTS.BODY_MEDIUM_BOLD}>{chunks}</Typography>
                ),
              }}
            />
          </AlertBanner>
        )}
        <div
          id="g_id_onload"
          data-client-id={window.env.OAUTH_GOOGLE_CLIENT_ID}
          data-login-uri="/auth/google/callback"
        />
      </Card.Body>
    </Card>
  );
};

export const LoginGoogleCard = memo(LoginGoogleCardBase);
